// extracted by mini-css-extract-plugin
module.exports = {"search":"user-search_search__1uVVy","results":"user-search_results__3BGWn","result":"user-search_result__3Sh0F"};